module.exports = __webpack_public_path__ + "img/bottom.76e9c56d.jpg";